import { entryCount, type AgendaSection } from './agendaModel';

const dayOf = (iso: string) => new Date(`${iso}T00:00:00Z`);
const long = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  timeZone: 'UTC',
});
const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'short', timeZone: 'UTC' });
const month = new Intl.DateTimeFormat('de-DE', { month: 'short', timeZone: 'UTC' });
const monthLong = new Intl.DateTimeFormat('de-DE', { month: 'long', timeZone: 'UTC' });

export const RAIL: Record<Exclude<AgendaSection['kind'], 'flat'>, string> = {
  today: 'bg-forest-deep text-white shadow-float',
  house: 'bg-forest-soft text-forest-deep',
  day: 'border-hairline border bg-white text-ink',
  past: 'bg-card-alt text-ink-soft',
};

/** Kachel, Titel und Hinweis eines Abschnitts. */
export function headOf(section: AgendaSection) {
  const count = entryCount(section);
  const date = section.date ? dayOf(section.date) : null;
  switch (section.kind) {
    case 'today':
      return {
        top: 'Heute',
        big: String(date!.getUTCDate()),
        bottom: monthLong.format(date!),
        title: 'Heute',
        hint: long.format(date!),
      };
    case 'house':
      return {
        top: 'Gerade',
        big: String(count),
        bottom: 'zu Gast',
        title: 'Im Haus',
        hint: 'reisen später ab',
      };
    case 'day':
      return {
        top: weekday.format(date!).replace('.', ''),
        big: String(date!.getUTCDate()),
        bottom: month.format(date!).replace('.', ''),
        title: long.format(date!),
        hint: `${count} ${count === 1 ? 'Anreise' : 'Anreisen'}`,
      };
    default:
      return {
        top: 'Vorbei',
        big: String(count),
        bottom: count === 1 ? 'Buchung' : 'Buchungen',
        title: 'Abgeschlossen oder storniert',
        hint: '',
      };
  }
}
